import React, { useContext, useEffect, useState } from "react";
import { TextField, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { ContextData } from "../../../../../../context/Context";
import axios from "axios";
import { toast } from "react-toastify";
import baseUrl from "../../../../../../BaseURL";
import SoundAlert from "../../../../../../routes/SoundAlert";
import { Putrequest } from "../../../../../../context/AxiosRequest";

function ResdentialAddress({ formData }) {
    
  const { UserTokens, ReloadBioForms, setReloadBioForms } = useContext(ContextData);

  const [formDatas, setFormDatas] = useState({

    residential_address:"",
    residential_status: "",
    years_in_apartment: "",
    nearest_landmark:  "",
    profession: "",
    profession_type: "",
    position:  "", 

  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDatas((prev) => ({ ...prev, [name]: value }));
  };

  const validateField = (type, value) => {
    if (["residential_status", "profession_type", "position"].includes(type)) {
      return value !== "";
    }

    if (type === "years_in_apartment") {
      return /^\d{1,3}$/.test(value.trim()); // 0–999 years
    }

    return value.trim() !== "";
  };

  const handleSubmit = async (type) => {


    if (!validateField(type, formDatas[type])) {
      SoundAlert("error");
      toast.error("Please fill in this field correctly.");
      return;
    }

    

      const response = await Putrequest("auth/update_resdential_address",{...formDatas,user_token:UserTokens})
       
                   
                       if(response.status){
    
                        SoundAlert("success")
                        toast.success(response.textStatus)
                        setReloadBioForms(!ReloadBioForms)
    
                          }



  };


useEffect(()=>{

       setFormDatas({
    residential_address: formData.residentialAddress.residential_address || "",
    residential_status: formData.residentialAddress.residential_status || "", 
    years_in_apartment: formData.residentialAddress.years_in_apartment || "",
    nearest_landmark: formData.residentialAddress.nearest_landmark || "",
    profession: formData.residentialAddress.profession || "",
    profession_type: formData.residentialAddress.profession_type || "", 
    position: formData.residentialAddress.position || "", 
       })

},[formData])





  return (
    <div className="pt-2 pb-2">
      {/* Residential Address */}
      <TextField
        label="Residential Address"
        name="residential_address"
        value={formDatas.residential_address}
        onChange={handleChange}
        fullWidth
        margin="dense"
        multiline
        rows={2}
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("residential_address")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Residential Status */}
      <FormControl component="fieldset" margin="dense" fullWidth>
        <FormLabel component="legend">Residential Status</FormLabel>
        <RadioGroup
          row
          name="residential_status"
          value={formDatas.residential_status}
          onChange={handleChange}
        >
          <FormControlLabel value="rented" control={<Radio />} label="Rented" />
          <FormControlLabel value="owned" control={<Radio />} label="Owned" />
        </RadioGroup>
        <Button variant="contained" color="secondary" onClick={() => handleSubmit("residential_status")}>
          Save
        </Button>
      </FormControl>

      {/* Years in Apartment */}
      <TextField
        label="Years in Apartment"
        name="years_in_apartment"
        value={formDatas.years_in_apartment}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        type="number"
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("years_in_apartment")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Nearest Landmark */}
      <TextField
        label="Nearest Landmark"
        name="nearest_landmark"
        value={formDatas.nearest_landmark}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("nearest_landmark")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Profession / Business / Others */}
      <TextField
        label="Employment / Business / Others (specify)"
        name="profession"
        value={formDatas.profession}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
        InputProps={{
          endAdornment: (
            <Button variant="outlined" color="secondary" onClick={() => handleSubmit("profession")}>
              Save
            </Button>
          ),
        }}
      />

      {/* Profession Type */}
      <FormControl component="fieldset" margin="dense" fullWidth>
        <FormLabel component="legend">Employment</FormLabel>
        <RadioGroup
          row
          name="profession_type"
          value={formDatas.profession_type}
          onChange={handleChange}
        >
          <FormControlLabel value="federal" control={<Radio />} label="Federal" />
          <FormControlLabel value="state" control={<Radio />} label="State" />
          <FormControlLabel value="local" control={<Radio />} label="Local" />
          <FormControlLabel value="other" control={<Radio />} label="Others" />
        </RadioGroup>
        <Button variant="contained" color="secondary" onClick={() => handleSubmit("profession_type")}>
          Save
        </Button>
      </FormControl>

      {/* Position */}
      <FormControl component="fieldset" margin="dense" fullWidth>
        <FormLabel component="legend">Position</FormLabel>
        <RadioGroup
          row
          name="position"
          value={formDatas.position}
          onChange={handleChange}
        >
          <FormControlLabel value="junior" control={<Radio />} label="Junior" />
          <FormControlLabel value="mid-level" control={<Radio />} label="Mid-Level" />
          <FormControlLabel value="management" control={<Radio />} label="Management" />
        </RadioGroup>
        <Button variant="contained" color="secondary" onClick={() => handleSubmit("position")}>
          Save
        </Button>
      </FormControl>
    </div>
  );
}

export default ResdentialAddress;
